import { Pagination, RequiredPaginationQueryParams } from "@CommonTypes/backend/pagination";
import { StoreProduct } from "@CommonApi/inputs/store-products";
import { Product } from "@CommonApi/inputs/products/all";
import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetInputsStoreProducts_storeId_ = "/inputs/store-products/:storeId";

export type ParamsGetInputsStoreProducts_storeId_ = ExtractRouteParams<
  typeof RouteGetInputsStoreProducts_storeId_
>;

export type QueryParamsGetInputsStoreProducts_storeId_ = Partial<RequiredPaginationQueryParams> & {
  search?: string;
  category_code?: string;
  retailer_category_code?: string;
};

export type ResponseGetInputsStoreProducts_storeId_ = Pagination<
  StoreProduct & Pick<Product, "product_code" | "upc" | "name">
>;
